import { render, staticRenderFns } from "./PerfilPermisos.vue?vue&type=template&id=47e66136&"
import script from "./PerfilPermisos.vue?vue&type=script&lang=js&"
export * from "./PerfilPermisos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports